import ButtonItems from './hooks/ButtonItems';
import Title from './components/Title';
import ButtonHamburguer from './components/Mobile/ButtonHamburguer';
import MenuHamburguer from './components/Mobile/MenuHamburguer';
import Profile from './components/Desktop/Profile';
import Items from './components/Items';

const EsriHeader = ({ currentUser, onLogout, activeTab, onTabChange, permission, losesAccess, theme, setTheme }) => {
  const vm = ButtonItems({activeTab, onTabChange, permission, losesAccess})
  const activePointProgram = permission.includes(6) && !permission.includes(18);
  const hasMobileModules = [1, 2, 3, 4, 11, 15].some((code) => permission.includes(code))
    || (!activePointProgram && permission.includes(6));

  return (
    <header className="bg-personalized text-white shadow-lg sticky top-0 z-40">
      <div className="w-full pl-3 pr-5 py-3 flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          {hasMobileModules && (
            <ButtonHamburguer navOpen={vm.navOpen} setNavOpen={vm.setNavOpen}/>
          )}
          <Title/>
        </div>
        <div className="flex items-center space-x-2">
          <nav className="hidden lg:block">
            <ul className="flex items-center gap-2">
              <Items
                navBtn={vm.navBtn}
                bondaAdminBtn={vm.bondaAdminBtn}
                activePointProgram={activePointProgram}
              />
            </ul>
          </nav>
          <Profile 
            btnRef={vm.btnRef}
            menuRef={vm.menuRef}
            menuOpen={vm.menuOpen}
            currentUser={currentUser}
            setMenuOpen={vm.setMenuOpen}
            onLogout={onLogout}
            theme={theme}
            setTheme={setTheme}
          />
        </div>
      </div>
      {hasMobileModules && (
        <MenuHamburguer
          navOpen={vm.navOpen}
          onLogout={onLogout}
          setNavOpen={vm.setNavOpen}
          navBtn={vm.navBtn}
          bondaAdminBtn={vm.bondaAdminBtn}
          activePointProgram={activePointProgram}
        />
      )}
    </header>
  );
};

export default EsriHeader;
